<template>
    <div>
        <input type="file" :accept="arquivosAceitos" hidden :ref="inputFileRef" @change="realizarUploadArquivo($event)"/>
        <a class="inativo" v-show="mostrarUploadSimples" @click.prevent.stop="abrirSelecaoArquivo">
            {{ labelArquivo }}<span v-if="isArquivoRequerido"> *</span>
        </a>
        <v-menu offset-y left v-if="mostrarDropDownAcoesArquivo">
            <a slot="activator" class="ativo">
                <span>
                    <v-icon>check</v-icon>{{ labelArquivo }}
                </span>
            </a>
            <v-list>
                <v-list-tile v-if="!isPropostaEnviada">
                    <v-list-tile-title @click="abrirSelecaoArquivo">
                        Trocar Arquivo
                    </v-list-tile-title>
                </v-list-tile>
                <v-list-tile :href="criarLinkDownloadArquivo()">
                    <v-list-tile-title>Baixar Arquivo</v-list-tile-title>
                </v-list-tile>
                <v-list-tile @click="confirmarRemocaoArquivo" v-if="!isPropostaEnviada">
                    <v-list-tile-title>Excluir Arquivo</v-list-tile-title>
                </v-list-tile>
            </v-list>
        </v-menu>
        <!--confirmacao remover anexo-->
        <az-confirm @onConfirm="removerArquivo" @onDecline="mostrarDialogRemoverArquivo = false"
                    v-if="mostrarDialogRemoverArquivo" :maxWidth=320>
            Tem certeza que deseja remover o arquivo?
        </az-confirm>
    </div>
</template>

<script>
    import {mapActions, mapState} from 'vuex'
    import {actionTypes} from '@/commons/constants'

    const FICHA_TECNICA = 'fichaTecnica'

    export default {
      name: 'LicitacaoFornecedorPropostaItemAnexo',
      props: {
          value: {
              required: true
          },
          tipoAnexo: {
              type: String,
              required: true,
              validator(value) {
                  return ['fichaTecnica', 'catalogo'].indexOf(value) !== -1
              }
          }
      },
      data() {
        return {
          mostrarDialogRemoverArquivo: false
        }
      },
      computed: {
        ...mapState(['licitacao', 'loki', 'propostaResumo', 'parametros']),
        inputFileRef() {
            return `${this.tipoAnexo}${this.value.licitacaoLoteItemId}`
        },
        arquivosAceitos() {
            return this.parametros.propriedadesLicitacao.extensao
        },
        isArquivoRequerido() {
          if (this.tipoAnexo === FICHA_TECNICA) {
            return this.value.incluirFicha
          }
          return this.value.incluirCatalogo
        },
        isPropostaEnviada() {
            return this.propostaResumo.enviada
        },
        labelArquivo() {
          if (this.tipoAnexo === FICHA_TECNICA) {
            return 'Ficha'
          }
          return 'Catalogo'
        },
        mostrarDropDownAcoesArquivo() {
          return !this.mostrarUploadSimples
        },
        mostrarUploadSimples() {
          const anexo = this.value[this.tipoAnexo]
          return !anexo
        },
        repository() {
          return `repo1:licitacao/${this.licitacao.id}/propostas/fornecedor/${this.loki.user.domainId}/propostaItens`
        }
      },
      methods: {
        ...mapActions([actionTypes.REMOVER_ARQUIVO_PROPOSTA_ITEM]),
        abrirSelecaoArquivo() {
          this.$refs[this.inputFileRef].click()
        },
        criarFormData(file) {
          const formData = new FormData()
          formData.append('file', file)
          formData.append('repository', this.repository)
          formData.append('thumbnail', 'false')
          return formData
        },
        criarLinkDownloadArquivo() {
          const anexo = this.value[this.tipoAnexo]
          if (anexo.id) {
              return this.criarLinkDownload(anexo.anexoUri)
          }
          return this.criarLinkDownloadTemporario(anexo.anexoUri)
        },
        confirmarRemocaoArquivo() {
          this.mostrarDialogRemoverArquivo = true
        },
        async realizarUploadArquivo(evento) {
          let arquivo = evento.target.files[0]
          const extensao = 'application/pdf'
          try {
            if (this.parametros.propriedadesLicitacao.extensao === extensao && arquivo.type !== extensao) {
              arquivo = null
              this.mostrarNotificacaoErro('O arquivo não foi anexado. Apenas o formato .pdf é aceito.')
              return
            }

            const tamanhoMaximoBytes = 30 * 1024 * 1024
            if (arquivo.size > tamanhoMaximoBytes) {
              this.mostrarNotificacaoErro('O arquivo ' + arquivo.name + ' ultrapassa o tamanho máximo permitido de 30MB para o Flowbee.')
              return
            }

            const arquivoUpado = await this.uploadFile({
                formData: this.criarFormData(arquivo),
                filename: arquivo.name
            })
            this.value[this.tipoAnexo] = {anexoUri: arquivoUpado.uri}
            this.emitirEventoUpload()
          } catch (e) {
            this.value[this.tipoAnexo] = null
          }
        },
        async removerArquivo() {
          const arquivo = this.value[this.tipoAnexo]
          if (arquivo.id) {
              await this.removerArquivoRemoto()
          } else {
              this.removerArquivoLocal()
          }
          this.emitirEventoRemover()
          this.mostrarDialogRemoverArquivo = false
        },
        async removerArquivoRemoto() {
          try {
            this.setMensagemLoading('Removendo anexo...')
            this.habilitarLoadingGlobal()
            await this.removerArquivoPropostaItem({
              licitacaoId: this.licitacao.id,
              tipoArquivo: this.tipoAnexo,
              propostaId: this.value.propostaId,
              licitacaoLoteItemId: this.value.licitacaoLoteItemId
            })
            this.removerArquivoLocal()
            this.mostrarNotificacaoSucessoDefault()
            this.desabilitarLoadingGlobal()
          } catch (e) {
            this.desabilitarLoadingGlobal()
          }
        },
        removerArquivoLocal() {
          this.value[this.tipoAnexo] = null
        },
        emitirEventoUpload(){
          this.$emit('eventoUpload')
        },
        emitirEventoRemover(){
           this.$emit('eventoRemover')
        }
      }
    }
</script>

<style lang="stylus">

    .anexos
        .v-btn
            width: 80px
            font-size: 11px
            height: 15px
            margin: 3px 0
            text-transform: none

        .ativo
            background-color: #7aa329
            color: white !important
            transition: 0.5s
            overflow: hidden
            display: block
            border: 1px solid #7aa329
            text-align: center
            font-size: 11px
            border-radius: 2px
            width: 65px
            align-items: center
            margin: 2px auto
            height: 18px
            i
                font-size: 14px
                color: white
                margin-right: 2px

        .inativo
            color: white !important
            transition: 0.5s
            overflow: hidden
            display: block
            border: 1px solid #aaa
            background-color: #aaa
            text-align: center
            font-size: 11px
            border-radius: 2px
            width: 65px
            align-items: center
            margin: 3px auto
            height: 18px
            i
                display: none
</style>